import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import ConfigValidationConstants from "../Constants/ConfigurationValidationConstants";

class ConfigurationValidationAction {
  getConfigValidation() {
    httpRequest(
      config.webServiceURL +
        "/ConfigurationValidation/GetConfigurationWarnings",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: ConfigValidationConstants.GET_CONFIG_VALIDATION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: ConfigValidationConstants.GET_CONFIG_VALIDATIONT_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new ConfigurationValidationAction();
